import { IRootState } from '../../../store'
import { ICompleteChartState } from '../store/completeChart.types'

export const getCompleteChartSelector = (state: IRootState): ICompleteChartState => state.completeChart
